import { useTranslation } from 'react-i18next'

import { useTheme } from 'styled-components'

import { Text } from '@reveni-io/reveni-ui'

import CriteriaEditor from '@/common/components/ConditionsEditor/CriteriaEditor/CriteriaEditor'
import { getIncompleteCriteriaIndexes } from '@/common/components/ConditionsEditor/helpers'
import { getBaseProductProperties } from '@/common/helpers/rules/helpers'

import * as Styles from './styles'

const AffectedProductsEditor = ({
  config,
  onChangeConfig,
  disabled,
  currencies,
  storeCurrencyCode,
  productTypes,
  productCategories,
  productCollections,
  hasError,
}) => {
  const theme = useTheme()
  const { t } = useTranslation()

  const productProperties = getBaseProductProperties({ productTypes, productCategories, productCollections })
  const errorCriteriaIndexes = hasError ? getIncompleteCriteriaIndexes(config.product_criteria) : []

  const handleChangeCriteria = criteria => onChangeConfig({ product_criteria: criteria })

  return (
    <Styles.Container>
      <Text type="bodyMBold">{t('Productos afectados')}</Text>
      <CriteriaEditor
        criteria={config.product_criteria}
        properties={productProperties}
        onChange={handleChangeCriteria}
        disabled={disabled}
        errorCriteriaIndexes={errorCriteriaIndexes}
        canAddCriteria
        currencies={currencies}
        storeCurrencyCode={storeCurrencyCode}
        inputBackgroundColor={theme.colors.background.primary}
      />
    </Styles.Container>
  )
}

export default AffectedProductsEditor
